import request from '@/utils/request'

export function listComplaints(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/complaint.listComplaints',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取业主投诉失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}